import {
  Button,
  ButtonProps,
  CircularProgress,
  Tooltip,
} from '@material-ui/core'
import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { useAppDispatch } from 'store/configureStore'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { saveBomItemIsPurchasingPart } from '../store/asyncActions/saveBomItemIsPurchasingPart'
import { bomItemIsPurchasingPartSelector } from '../store/selectors/bomItemIsPurchasingPartSelector'
import { ProjectEditableStateSelector } from '../store/selectors/ProjectEditableStateSelector'
import { ProjectInBuyerViewSelector } from '../store/selectors/projectInBuyerViewSelector'
import { projectOperationSelector } from '../store/selectors/projectOperationPendingSelector'

export const PurchasingItemButton = ({
  bomItemId,
  buttonProps,
  useIconAtStart,
}: {
  bomItemId: string
  useIconAtStart?: boolean
  buttonProps?: ButtonProps
}) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const bomItemIsPurchasingPart = useAppSelector(
    bomItemIsPurchasingPartSelector(bomItemId)
  )

  const projectIsEditable = useAppSelector(ProjectEditableStateSelector)
  const isBuyerView = useAppSelector(ProjectInBuyerViewSelector)

  const operationStatus = useAppSelector(
    projectOperationSelector(
      saveBomItemIsPurchasingPart.typePrefix.concat('/', bomItemId)
    ),
    isEqual
  )

  if (isBuyerView) {
    return null
  }

  const handleClick = (e: {
    preventDefault: () => void
    stopPropagation: () => void
  }) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(saveBomItemIsPurchasingPart({ bomItemId }))
  }

  const ButtonIcon = () =>
    operationStatus?.requestStatus === 'pending' ? (
      <CircularProgress size={16} />
    ) : (
      <WorkingStepIconSvg
        workingStepType={WorkingStepType.Purchasing}
        attributes={{
          width: '24px',
        }}
        disableTitle
      />
    )

  return (
    <Tooltip
      title={
        bomItemIsPurchasingPart
          ? t('project:purchasing-part-unset', 'unset as purchasing part')
          : t('project:purchasing-part-set', 'set as purchasing part')
      }
      arrow
    >
      <span>
        <Button
          {...buttonProps}
          size={buttonProps?.size || 'small'}
          variant="text"
          disabled={!projectIsEditable}
          color={bomItemIsPurchasingPart ? 'primary' : 'default'}
          onClick={handleClick}
          endIcon={!useIconAtStart && <ButtonIcon />}
          startIcon={useIconAtStart && <ButtonIcon />}
          style={{
            minWidth: 0,
          }}
          // endIcon={

          // }
        >
          <>
            {bomItemIsPurchasingPart ? (
              <LocalizedTypography
                color={bomItemIsPurchasingPart ? 'primary' : 'textSecondary'}
                variant="caption"
                translationKey="common:purchasing-part"
              >
                purchasing
              </LocalizedTypography>
            ) : null}
          </>
        </Button>
      </span>
    </Tooltip>
  )
}
